import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button, Icon, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { PASSES_LANDING, VIEWER_PAGE } from "src/settings/constant";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
/**
 * 무료체험으로 보유 → 사용 유도 모듈 (Case 3)
 * - 보유중인 자료 헤더
 * - 열람 및 출력 버튼
 * - 패스 구매하고 PDF 파일로 받기 링크
 */ const PurchaseAlreadyOwnedTab = (param)=>{
    let { product , freeTrialData , className , isInModal  } = param;
    const router = useRouter();
    const homeType = useHomeSwitchStore((state)=>state.homeType);
    var _freeTrialData_licenseId;
    // 뷰어 열 때 사용할 ID (무료획득 직후에는 freeTrialData.licenseId 사용, 그 외에는 product.licenseId 사용)
    const viewerId = (_freeTrialData_licenseId = freeTrialData.licenseId) !== null && _freeTrialData_licenseId !== void 0 ? _freeTrialData_licenseId : product.licenseId;
    // 열람 및 출력 클릭 핸들러 - 뷰어로 이동
    const handleViewClick = ()=>{
        if (!viewerId) {
            return;
        }
        const viewerUrl = "".concat(VIEWER_PAGE, "/").concat(viewerId);
        mixpanelEvent("CTA Button Clicked", {
            "Button Type": "case3)무료체험으로 자료 획득한 유저",
            "Button Name": isInModal ? "뷰어로 열람" : "열람 및 출력",
            "Button URL": viewerUrl,
            Position: "상품상세페이지 구매모듈"
        });
        router.push(viewerUrl);
    };
    // 패스 구매하고 PDF 파일로 받기 클릭 핸들러
    const handlePurchaseClick = ()=>{
        const buttonUrl = "".concat(PASSES_LANDING, "/").concat(homeType);
        mixpanelEvent("CTA Button Clicked", {
            "Button Type": "case3)무료체험으로 자료 획득한 유저",
            "Button Name": "패스 구매하고 PDF 파일로 받기",
            "Button URL": buttonUrl,
            Position: "상품상세페이지 구매모듈"
        });
        window.open(buttonUrl, "_blank");
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex flex-col", className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "p-5 pt-0",
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle1",
                    className: "text-secondary flex justify-center",
                    children: "보유중인 자료"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "-mx-5 h-px w-[calc(100%+40px)] bg-gray-50"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 pt-5",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "fill",
                        color: "primary",
                        size: "lg",
                        fullWidth: true,
                        onClick: handleViewClick,
                        children: isInModal ? "뷰어로 열람" : "열람 및 출력"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "text",
                        color: "primary",
                        size: "sm",
                        fullWidth: true,
                        rightElement: /*#__PURE__*/ _jsx(Icon.ArrowRight_2px, {
                            className: "text-primary-main size-4.5"
                        }),
                        onClick: handlePurchaseClick,
                        children: "패스 구매하고 PDF 파일로 받기"
                    })
                ]
            })
        ]
    });
};
export default PurchaseAlreadyOwnedTab;
